import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Item", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Match", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("dt", null, "Unlocked Game", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", null, "Renew Time", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", null, "Start Time", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", null, "Open Time", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, "Close Time", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("dt", null, "Rank Time", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", null, "Archive Time", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("dt", null, "End Time", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", null, "Status", -1)
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "card-footer bg-white border border-light" }
const _hoisted_18 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_ctx.cycle)
    ? (_openBlock(), _createBlock(_component_app_card, {
        key: 0,
        class: "col-lg-8 mx-auto",
        label: "Duplicate Cycle Detail"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("dl", _hoisted_2, [
              _createElementVNode("tr", null, [
                _hoisted_3,
                _createElementVNode("dd", null, _toDisplayString(_ctx.cycle.id), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_4,
                _createElementVNode("dd", null, [
                  _createVNode(_component_router_link, {
                    to: { name: _ctx.ROUTE_NAME_DUPLICATE.ITEM.DETAIL, params: { id: _ctx.cycle.duplicateItemId } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.cycle.itemName), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_5,
                _createElementVNode("dd", null, [
                  _createVNode(_component_router_link, {
                    to: { name: _ctx.ROUTE_NAME_GAME.MATCH.DETAIL, params: { id: _ctx.cycle.matchId } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.cycle.matchName), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_6,
                _createElementVNode("dd", null, _toDisplayString(`${_ctx.cycle.unlockedGame}/${_ctx.cycle.itemGame}`), 1)
              ]),
              (_ctx.cycle.renewTime)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.cycle.renewTime)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_9,
                _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.cycle.startTime)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.cycle.openTime)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.cycle.closeTime)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.cycle.rankTime)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_13,
                _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.cycle.archiveTime)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.cycle.endTime)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_15,
                _createElementVNode("dd", {
                  innerHTML: _ctx.renderOption(_ctx.DuplicateCycleStatus, _ctx.cycle.status)
                }, null, 8, _hoisted_16)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_app_button, {
                name: "Show Decks",
                icon: "fa-ticket-alt",
                theme: "info",
                to: {
                        name: _ctx.ROUTE_NAME_DUPLICATE.CYCLE.DECK,
                        params: { cycleId: _ctx.cycle.id, itemId: _ctx.cycle.duplicateItemId }
                    }
              }, null, 8, ["to"])
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}